export const SHAKESHAKE_CONNECTIONSTRING = 'config_shakeshake_connectionstring';
export const SHAKESHAKE_TOPIC = 'config_shakeshake_topic';
export const GETSTARTED_CONNECTIONSTRING = 'config_getstared_connectionstring';



// WEBPACK FOOTER //
// ./src/constants/localStorageKeys.js